<div class="header-bar">
  <h1>Delay Failure Templates</h1>
</div>
<div class="content-container">
  <div class="text-center p-5" *ngIf="!isLoaded">
    <i class="fa fa-spin fa-spinner fa-2x"></i>
  </div>

  <div *ngIf="isLoaded && delayFailureTemplates.length > 0">
    <p-table
      [value]="delayFailureTemplates"
      [paginator]="true"
      [rows]="10"
      selectionMode="single"
      [(selection)]="responseSelected"
      [totalRecords]="delayFailureTemplates.length"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="headline">
            Summary
            <i class="fa fa-exclamation-circle" pTooltip="Headline"></i>
          </th>
          <th pSortableColumn="senderName">E-mail Subject Line</th>
          <th pSortableColumn="senderAddress">E-mail Body</th>
          <th pSortableColumn="added" style="width: 150px">Added</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr (dblclick)="editResponse(item)" [pSelectableRow]="item">
          <td>{{ item.headline }}</td>
          <td>{{ item.subjectTemplate }}</td>
          <td>{{ item.bodyTemplate }}</td>
          <td class="text-center">{{ item.added | datex : 'DD/MM/YY HH:mm' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="ui-g">
    <div class="ui-g-12">
      <button
        pButton
        type="button"
        label="Create Delay Failure Template"
        class="ui-button ui-button-primary btn-to-right pull-right"
        (click)="createQuestion()"
      ></button>

      <button
        *ngIf="responseSelected != null"
        pButton
        type="button"
        label="Edit"
        class="ui-button ui-button-tertiary btn-to-right pull-right"
        (click)="editResponse(responseSelected)"
      ></button>

      <button
        *ngIf="responseSelected != null"
        pButton
        type="button"
        label="Delete"
        class="ui-button ui-button-danger btn-to-right pull-right"
        (click)="deleteDelayFailureTemplate()"
      ></button>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>

<p-dialog
  [header]="editMode ? 'Edit More Information Response' : 'Create More Information Response'"
  [(visible)]="showEditForm"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
>
  <form [formGroup]="editForm" *ngIf="showEditForm">
    <div class="ui-g">
      <div class="ui-g-4">
        <input type="hidden" formControlName="id" />
        <div class="input-label">
          Summary
          <i
            class="fa fa-exclamation-circle"
            pTooltip="Internal name for reason, not shown to Supplier"
          ></i>
        </div>
        <div class="input-value">
          <input
            required
            pInputText
            formControlName="headline"
            maxlength="30"
            style="width: 100%"
          />
        </div>
      </div>
      <!-- Don't need-->
      <div class="ui-g-12">
        <!--<div class="input-label">Recipent E-mail Address</div>
        <div class="input-value">
          <input
            required
            pInputText
            formControlName="recipientAddressTemplate"
            style="width: 100%"
          />
        </div>-->

        <div class="input-label">E-mail Subject Line</div>
        <div class="input-value">
          <input required pInputText formControlName="subjectTemplate" style="width: 100%" />
        </div>

        <div class="input-label">E-mail Body</div>
        <div class="input-value">
          <textarea
            pInputTextarea
            formControlName="bodyTemplate"
            style="width: 100%; height: 150px"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="">
      <!--
      <div class="ui-g-12 ui-md-6">
        
        <div class="input-label">Sender E-mail</div>
        <div class="input-value">
          <input
            pInputText
            type="email"
            formControlName="senderAddressTemplate"
            style="width: 100%"
          />
        </div>

        <div class="input-label">Sender Name</div>
        <div class="input-value">
          <input pInputText formControlName="senderNameTemplate" style="width: 100%" />
        </div>
      </div>-->
      <!--
      <div class="ui-g-12 ui-md-6">
        <div class="input-label">ReplyTo E-mail</div>
        <div class="input-value">
          <input
            pInputText
            [placeholder]="editForm.get('senderAddressTemplate').value"
            type="email"
            formControlName="replyToAddressTemplate"
            style="width: 100%"
          />
        </div>

        <div class="input-label">ReplyTo Name</div>
        <div class="input-value">
          <input
            pInputText
            [placeholder]="editForm.get('senderNameTemplate').value"
            formControlName="replyToNameTemplate"
            style="width: 100%"
          />
        </div>
      </div>-->

      <div class="w-100">
        <!--<div class="flex-shrink-1 pl-2" style="line-height: 33px" (click)="showHelp = !showHelp">
          <i class="fa fa-question-circle"></i>
          <span style="display: inline-block; line-height: 33px; margin-left: 5px">Help</span>
        </div>-->
        <div class="text-right">
          <button
            pButton
            type="button"
            label="Cancel"
            class="ui-button ui-button-tertiary"
            (click)="showEditForm = false"
          ></button>

          <button
            pButton
            type="button"
            label="Save"
            [disabled]="!editForm.valid"
            class="ui-button ui-button-primary"
            (click)="saveResponse()"
          ></button>
        </div>
      </div>
    </div>
  </form>
  <!--<div *ngIf="showHelp" class="p-2">
    <div>Available models (No need for nested syntax, eg. task.order.job)</div>
    <div class="pt-2">
      <div class="d-flex grid-gap-10 w-100" style="font-weight: bold">
        <div>AdditionalCharge</div>
        <div>Task</div>
        <div>Order</div>
        <div>Job</div>
        <div>Supplier</div>
        <div>User</div>
      </div>
    </div>

    <div class="pt-2">NOTE: Pascal case fields should be entered as Snake Case</div>
    <div class="pt-2">eg. JobNumber should be job_number</div>
    <div class="pt-3">
      More information on
      <a _target="_new" href="https://shopify.github.io/liquid/">Liquid syntax</a>
    </div>
  </div>-->
</p-dialog>
